import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { AlertCircle } from 'lucide-react';
import PlantImage from '../components/fancyplants/PlantImage';

const RegisterPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await register(email, password);
      navigate('/account');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="min-h-screen bg-canvas pt-16">
      <div className="container-fp grid items-stretch gap-0 py-10 lg:grid-cols-2">
        <div className="relative hidden overflow-hidden rounded-l-3xl bg-forest-900 lg:block">
          <PlantImage
            src="https://images.unsplash.com/photo-1485955900006-10f4d324d411?auto=format&fit=crop&w=900&q=70"
            alt="A windowsill of exotic plants"
            ratio="auto"
            className="absolute inset-0 h-full w-full opacity-60"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-green-900 to-green-900/40" />
          <div className="relative flex h-full flex-col justify-end p-10 text-canvas">
            <div className="mb-3 flex items-baseline gap-1.5">
              <span className="font-display text-3xl">Fancy</span>
              <span className="font-display text-3xl italic text-brass">Plants</span>
            </div>
            <ul className="space-y-1.5 text-canvas/80">
              <li>• Track your orders end to end</li>
              <li>• Save a wishlist of plants you love</li>
              <li>• Leave verified reviews after delivery</li>
              <li>• First to hear when rare stock lands</li>
            </ul>
          </div>
        </div>

        <div className="surface rounded-3xl p-8 sm:p-10 lg:rounded-l-none lg:border-l-0">
          <p className="eyebrow mb-2">Join us</p>
          <h1 className="t-h2 mb-6">Create your account</h1>
          <form onSubmit={handleSubmit} className="space-y-4">
            <label className="block">
              <span className="mb-1.5 block text-sm font-medium">Email</span>
              <input
                type="email"
                autoComplete="email"
                required
                className="fp-input"
                placeholder="you@email.ie"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </label>
            <label className="block">
              <span className="mb-1.5 block text-sm font-medium">Password</span>
              <input
                type="password"
                autoComplete="new-password"
                required
                className="fp-input"
                placeholder="Choose a password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>

            {error && (
              <p className="flex items-center gap-2 rounded-xl bg-danger/10 px-4 py-3 text-sm text-danger">
                <AlertCircle size={16} /> {error}
              </p>
            )}

            <button type="submit" className="btn-brass w-full">Create account</button>
          </form>

          <p className="mt-6 text-center text-sm text-ink-soft">
            Already have an account?{' '}
            <Link to="/login" className="link-underline font-semibold">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
